var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bannerType)?_c('Banner',{attrs:{"bannerText":_vm.bannerText,"bannerType":_vm.bannerType,"learnMoreLink":"https://status.jumpcloud.com/","learnMoreText":"View status page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }